import React, { PropTypes } from 'react'
import { connect } from 'react-redux'
import Select from 'react-select'
import { Actions as actions } from 'unity-core'
import { reloadModuleBundle } from 'loader'

const AvailableUpdates = ({ updates, updateAppModule }) => {
    if (!updates || updates.length == 0) return null

    const update = (x) => {
        updateAppModule({ bundle: x.bundle, updater: reloadModuleBundle })
    }

    return <div className="pull-left">
        <div className="pull-left slide-top-10" style={{ 'paddingRight': '20px', 'minWidth': '250px' }}>

            <Select name="availableUpdates"
                style={{ border: '2px solid #ccc' }}
                optionComponent={(p) => {
                    const { option } = p
                    return (
                        <div><span onClick={() => p.onSelect(option)} style={{ cursor: 'pointer', paddingLeft: '10px' }}>
                            <span className="glyphicon glyphicon-download" aria-hidden="true"></span> &nbsp;
              <strong>New version of {option.name} ({option.new_ver}) is available &nbsp; <button className="btn btn-xs btn-warning" onClick={() => update(option)}>Update</button></strong>
                        </span></div>
                    )
                }}
                valueComponent={(p) => {
                    const { value } = p
                    if (!value) return null
                    return <span style={{ paddingLeft: '10px', paddingTop: '10px' }}>
                        <span className="glyphicon glyphicon-download" aria-hidden="true"></span> &nbsp;
            <strong>New version of {value.name} ({value.new_ver}) is available &nbsp; <button className="btn btn-xs btn-warning" onClick={() => update(value)}>Update</button></strong>
                    </span>
                }}
                value={updates && updates.length > 0 ? updates[0] : null}
                labelKey="name"
                valueKey="bundle"
                options={updates} />

        </div>
    </div>
}

const mapStateToProps = (state) => ({
    updates: state.app.updates
})

const mapDispatchToProps = (dispatch) => ({
    updateAppModule: (evt) => dispatch(actions.App.updateAppModule(evt))
})

export default connect(mapStateToProps, mapDispatchToProps)(AvailableUpdates)